.googleForm {
  width: 100%;
}

/* The Google button and its separator, grouped so they can be hidden together. Its children are laid
 * out exactly as when they were direct children of the gate's flex column. */
.entry {
  display: contents;

  &[hidden] {
    display: none;
  }
}

/* Override Button variant="secondary" — spec §7a: white bg, #333 text, full-width (narcis default).
 * Colors/weight/size/tracking exposed as CSS custom properties (2026-07-14) so a product with a
 * different auth-gate register (ovid's ghost-button House convention) can remap without forking
 * this component — a CSS-var remap on an ancestor cannot touch a hardcoded literal, which is
 * exactly why ovid's prior "already CSS-var wired" claim was false on the rendered surface: this
 * button had no vars to remap. Every default below reproduces the original narcis literal
 * exactly, so narcis/quies render byte-identical unless a --auth-google-... or --auth-control-...
 * var is set upstream (only ovid's authGateVars mixin does).
 */
.googleButton {
  width: 100%;
  background: var(--auth-google-bg, #ffffff) !important;
  background-image: none !important;
  color: var(--auth-google-text, #333333) !important;
  border: 1px solid var(--auth-google-border, rgba(0, 0, 0, 0.12)) !important;
  border-radius: var(--radius-md) !important;
  font-family: var(--font-body) !important;
  font-weight: var(--auth-control-weight, 500) !important;
  font-size: var(--auth-control-size, 0.9375rem) !important;
  /* .button's base rule (button.module.scss) sets 0.025em when unoverridden — that's the
   * narcis-preserving default here, not "normal". */
  letter-spacing: var(--auth-control-tracking, 0.025em) !important;
}

.separator {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  color: var(--text-muted);
  font-size: 0.85rem;
  margin: 4px 0;

  &::before, &::after {
    content: '';
    flex: 1;
    border-top: 1px solid var(--border);
  }
}
